import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

interface Props {
    setQuantity: (boxes: number) => void;
    quantityS?: string;
    quantityB: any;
    enabledEyes: any;
}

const noDiscount = {
    annualSupplyBoxes: 0,
    sixMonthsSupplyBoxes: 0,
    annualSupplySavings: 0,
    sixMonthsSupplySavings: 0,
};

const CLDiscounts = ({ setQuantity, quantityS, quantityB, enabledEyes }: Props) => {
    const config = useSelector((state: RootState) => state.common.config);
    const discountData = config?.discountData || noDiscount;
    const { annualSupplyBoxes, sixMonthsSupplyBoxes, annualSupplySavings, sixMonthsSupplySavings } =
        discountData;
    const showAnnualSupply = annualSupplyBoxes > 0;
    const showSixMonthsSupply = sixMonthsSupplyBoxes > 1 && showAnnualSupply;
    const showDiscountSection = showAnnualSupply || showSixMonthsSupply;
    const annualBoxesPerEye = annualSupplyBoxes / 2;
    const sixMonthsBoxesPerEye = sixMonthsSupplyBoxes / 2;
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        const rightQuantity = enabledEyes.rightEye ? parseInt(quantityB.rightQuantity) : 0;
        const leftQuantity = enabledEyes.leftEye ? parseInt(quantityB.leftQuantity) : 0;
        const totBoxes = rightQuantity + leftQuantity;

        if (!!totBoxes && annualSupplyBoxes && totBoxes >= annualSupplyBoxes) {
            setSelectedOption('annual');
        } else if (!!totBoxes && sixMonthsSupplyBoxes && totBoxes >= sixMonthsSupplyBoxes) {
            setSelectedOption('sixMonths');
        } else {
            setSelectedOption('');
        }
    }, [quantityS, quantityB]);

    useEffect(() => {
        if (config.isExternalFeed) {
            setSelectedOption('');
        }
    }, []);

    const handleClick = (quantity: number, option: string) => {
        setQuantity(quantity);
        setSelectedOption(option);
    };

    return (
        <>
            {showDiscountSection && (
                <div className="contact-lens-discount-container">
                    {showSixMonthsSupply && (
                        <button
                            className={`annual-supply-discount ${
                                selectedOption === 'sixMonths' ? 'active' : ''
                            }`}
                            onClick={() => handleClick(sixMonthsBoxesPerEye, 'sixMonths')}
                        >
                            <span className="six_months_boxes d-none">{sixMonthsSupplyBoxes}</span>
                            {sixMonthsSupplySavings != 0 && (
                                <span
                                    className={`supply-tooltip ${
                                        selectedOption === 'sixMonths' ? 'active' : ''
                                    }`}
                                >
                                    {sixMonthsSupplySavings} off
                                </span>
                            )}
                            <input
                                type="radio"
                                id="six-months-supply"
                                name="supply-option"
                                checked={selectedOption === 'sixMonths'}
                                readOnly
                            />
                            <label htmlFor="six-months-supply">
                                <span className="months">6 months</span>
                                <br />
                                <span className="boxes">{sixMonthsSupplyBoxes} boxes or more</span>
                            </label>
                        </button>
                    )}

                    {showAnnualSupply && (
                        <button
                            className={`annual-supply-discount ${
                                selectedOption === 'annual' ? 'active' : ''
                            }`}
                            onClick={() => handleClick(annualBoxesPerEye, 'annual')}
                        >
                            <span className="one_year_boxes d-none">{annualSupplyBoxes}</span>
                            <span
                                className={`supply-tooltip ${
                                    selectedOption === 'annual' ? 'active' : ''
                                }`}
                            >
                                {annualSupplySavings} off
                            </span>
                            <input
                                type="radio"
                                id="annual-supply"
                                name="supply-option"
                                checked={selectedOption === 'annual'}
                                readOnly
                            />
                            <label htmlFor="annual-supply">
                                <span className="months">12 months</span>
                                <br />
                                <span className="boxes">{annualSupplyBoxes} boxes or more</span>
                            </label>
                        </button>
                    )}
                </div>
            )}
        </>
    );
};

export default CLDiscounts;
